// 获取比赛结果页 widget navs
export const getResultWidgetsNavs = (sportId) => {
  switch (sportId) {
    case 'sr:sport:1': // soccer
      return [
        {
          label: 'Timeline',
          name: 'timeLine',
          children: [
            {
              label: 'Highlights',
              name: 'verticalTimeline'
            },
            {
              label: 'Full Time Line',
              name: 'commentary'
            }
          ]
        },
        {
          label: 'Statistics',
          name: 'statistics'
        },
        {
          label: 'Lineups',
          name: 'lineups'
        }
      ]
    case 'sr:sport:137': // esport soccer
      return [
        {
          label: 'Timeline',
          name: 'timeLine',
          children: [
            {
              label: 'Highlights',
              name: 'verticalTimeline'
            },
            {
              label: 'Full Time Line',
              name: 'commentary'
            }
          ]
        },
        {
          label: 'Lineups',
          name: 'lineups'
        }
      ]
    case 'sr:sport:2': // basketball
      return [
        {
          label: 'TimeLine',
          name: 'timeLine',
          children: [
            {
              label: 'Highlights',
              name: 'verticalTimeline'
            },
            {
              label: 'Full Time Line',
              name: 'commentary'
            }
          ]
        },
        {
          label: 'Statistics',
          name: 'statistics'
        },
        {
          label: 'Team Roster',
          name: 'basketballTeamRoster'
        }
      ]
    case 'sr:sport:153': // esport basketball
      return [
        {
          label: 'TimeLine',
          name: 'timeLine',
          children: [
            {
              label: 'Highlights',
              name: 'verticalTimeline'
            },
            {
              label: 'Full Time Line',
              name: 'commentary'
            }
          ]
        },
        {
          label: 'Team Roster',
          name: 'basketballTeamRoster'
        }
      ]
    case 'sr:sport:109': // Counter-Strike
    case 'sr:sport:110': // League of Legends
    case 'sr:sport:111': // Dota2
      return [
        {
          label: 'Statistics',
          name: 'iframe-statistics'
        }
      ]
    case 'sr:sport:13': // Aussie Rules
    case 'sr:sport:10': // Boxing
    case 'sr:sport:118': // Call of duty
    case 'sr:sport:113': // Heartstone
    case 'sr:sport:121': // Overwatch
    case 'sr:sport:125': // Rainbow six
    case 'sr:sport:128': // Rocket League
    case 'sr:sport:112': // StarCraft
      return null
    default:
      return [
        {
          label: 'lmtPlus',
          name: 'lmtPlus'
        }
      ]
  }
}
